import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UpdateClientInformationComponent} from "./update-client-information.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";



@NgModule({
  declarations: [
    UpdateClientInformationComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    GeneralModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    UpdateClientInformationComponent
  ]
})
export class SalesUpdateClientInformationModule { }
